// preferenze.ts — preferenze sul dispositivo (tema, aspetto, lingua).
// localStorage può mancare o lanciare errori (navigazione privata, anteprime): ogni accesso è protetto
// e l'app funziona comunque, con i valori predefiniti.

export function leggiPreferenza(chiave: string): string | null {
  try {
    return window.localStorage.getItem(chiave);
  } catch {
    return null;
  }
}

export function salvaPreferenza(chiave: string, valore: string): void {
  try {
    window.localStorage.setItem(chiave, valore);
  } catch {
    // non salvata: al prossimo avvio si useranno i valori predefiniti
  }
}
